
const statusList = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" }
];

const onOff = [
    { label: "On", value: "on" },
    { label: "Off", value: "off" }
];


const emailSmsConfigData = [
    { label: "NONE", value: "NONE" },
    { label: "ENV Vars", value: "ENV" },
    { label: "Setting Vars", value: "SETTING" }
];

const SettingsData: any = {

    configVars: [
        {
            cols: [
                {
                    name: "email_config_vars", label: "Send Email with", required: true, validate: "string", md: 4,
                    type: "select", list: emailSmsConfigData
                },
                {
                    name: "sms_config_vars", label: "Send Sms with", required: true, validate: "string", md: 4,
                    type: "select", list: emailSmsConfigData
                },
                {
                    name: "offline_mode", label: "Offline mode", required: true, validate: "string", md: 4,
                    type: "select", list: onOff
                },
                {
                    name: "captcha", label: "Captcha", required: true, validate: "string", md: 4,
                    type: "select", list: onOff
                },
                {
                    name: "late_checkout", label: "Late checkout", required: true, validate: "string", md: 4,
                    type: "select", list: onOff
                },
                {
                    name: "Android_app_version", label: "Android App Version", required: true, validate: "string", md: 4,
                    type: "text",
                },
                {
                    name: "iOS_app_version", label: "iOS App Version", required: true, validate: "string", md: 4,
                    type: "text",
                },
                {
                    name: "Android_force_update", label: "Android Force Update", required: true, validate: "string", md: 4,
                    type: "select", list: onOff
                },
                {
                    name: "iOS_force_update", label: "iOS Force Update", required: true, validate: "string", md: 4,
                    type: "select", list: onOff
                },
                {
                    name: "map_distance", label: "Map  Distance (Meter)", required: true, validate: "string", md: 4,
                    type: "text"
                },
                {
                    name: "Android_app_store_link", label: "Android Play Store Link", required: true, validate: "string", md: 4,
                    type: "text",
                },
                {
                    name: "iOS_app_store_link", label: "iOS App Store Link", required: true, validate: "string", md: 4,
                    type: "text",
                },
            ]
        }

    ],
    app: [
        {
            cols: [
                { name: "splash_screen", label: "Mobile Splash Screen", required: true, type: "file", accept: "image/*" }
            ]
        }
    ],
    general: [
        {
            cols: [
                { name: "mobile_app_logo", label: "Mobile App Logo", required: true, type: "file", validate: "string" },
                { name: "website_name", label: "Website Name", required: true, validate: "string" },
            ],
        },
        {
            cols: [
                { name: "app_name", label: "App Name", required: true, type: "text" },
                { name: "website_logo", label: "Website Logo", required: true, type: "file" },
            ],
        },
        {
            cols: [

                {
                    name: "status", label: "status", required: false, validate: "string", md: 3,
                    type: "select", list: statusList
                },
            ]
        }

    ],
    sms: [
        {
            cols: [

                { name: "sms_apikey", label: "Api Key", required: true, validate: "string" },
                { name: "sms_sender", label: "Sender", required: true, validate: "string" },
            ],
        },
        {
            cols: [

                { name: "sms_route", label: "Route", required: true, validate: "string" },
                { name: "sms_from_name", label: "From Name", required: true, validate: "string" },
            ],
        },
        {
            cols: [

                { name: "sms_dlttempid", label: "DLTTEMPID", required: true, validate: "string" },
                {
                    name: "status", label: "Status", required: false, validate: "string",
                    type: "select", list: statusList
                },
            ],
        },


    ],
    smtp: [
        {
            cols: [

                { name: "smtp_protocol ", label: "Protocal", required: true, validate: "string" },
                { name: "smtp_host", label: "Host", required: true, validate: "string" },
            ],
        },
        {
            cols: [

                { name: "smtp_port", label: "Port", required: true, validate: "string" },
                { name: "smtp_user", label: "User", required: true, validate: "string" },
            ],
        },
        {
            cols: [

                { name: "smtp_pass", label: "Password", required: true, validate: "string" },
                {
                    name: "status", label: "Status", required: false, validate: "string",
                    type: "select", list: statusList
                },
            ],
        },
    ],
    storage: [
        {
            cols: [
                { name: "storage_type", label: "Storage Type", required: true, validate: "string" },
                { name: "aws_access_key", label: "Aws Access Key", required: true, validate: "string" },
            ],
        },
        {
            cols: [

                { name: "aws_secret_key", label: "Sws Secret Key", required: true, validate: "string" },
                { name: "aws_region", label: "Aws Region", required: true, validate: "string" },
            ],
        },
        {
            cols: [
                { name: "aws_bucket_name", label: "Aws Bucket Name", required: false, validate: "string" },
                {
                    name: "status", label: "Status", required: true, validate: "string",
                    type: "select", list: statusList
                },
            ],
        },
    ],
    notification: [
        {
            cols: [
                {
                    name: "email", label: "Email", required: true, validate: "string",
                    type: "select", list: onOff
                },
                {
                    name: "sms", label: "Sms", required: true, validate: "string",
                    type: "select", list: onOff
                },
                {
                    name: "push", label: "Push", required: true, validate: "string",
                    type: "select", list: onOff
                }
            ],
        },

    ]
}
export default SettingsData;